module.exports = __webpack_public_path__ + "img/home-icon.aac465e5.png";